import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import mailboxSvg from '../../assets/img/mailbox.svg';

const Container = styled.div`
  background-color: #f5f5f5;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Card = styled.div`
  max-width: 400px;
  margin: 1rem 1rem 4rem 1rem;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.176) 0px 4px 8px;

  > div:first-child {
    flex: 60%;
    padding: 2rem;
    background-color: #062333;
  }

  > div:last-child {
    flex: 40%;
    padding: 1rem;
    background-color: white;
  }
`;

export const MagicLinkContainer: FunctionComponent<
  React.HTMLAttributes<HTMLDivElement>
> = props => {
  const { children, ...containerProps } = props;
  return (
    <Container {...containerProps}>
      <Card>
        <div>
          <img src={mailboxSvg} alt="" />
        </div>
        <div>{children}</div>
      </Card>
    </Container>
  );
};
